import { combineReducers } from 'redux';

import {loginReducer} from './loginReducer';

import {helpbarReducer} from './helpbarReducer'
import {authReducer} from './authReducer'

import {
  guideReducer,
  guideDetailReducer,
  guideDetailRead
} from './guideReducer'

import {
  statisticsReducer
} from './statisticsReducer'

import {
  contactReducer
} from './contactReducer'
import {
  awardsReducer
} from './awardsReducer'


const rootReducer = combineReducers({
      loginReducer,
      helpbarReducer,
      authReducer,
      guideReducer,
      guideDetailReducer,
      guideDetailRead,
      statisticsReducer,      
      contactReducer,
      awardsReducer
})
   
export default rootReducer


// WEBPACK FOOTER //
// ./src/reducers/index.js